export const extrairCPF = (solicitacao) => {
  const pj =
    solicitacao?.produto?.nome.includes("PJ") ||
    solicitacao?.produto?.nome.includes("Jurídica") ||
    solicitacao?.produto?.tipoPessoa === "LEGAL_ENTITY";

  const cpf = pj
    ? solicitacao.cliente.pessoaJuridica.responsavel.cpf
    : solicitacao.cliente.pessoaFisica.cpf;

  return cpf;
};

export const somenteDigitos = (valor) => valor?.replace(/\D/g, "");
